import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    // user states: undefined = checking, null = unauthenticated, object = authenticated
    const [user, setUser] = useState(undefined);

    const refreshMe = useCallback(async () => {
        const t = getToken();
        if (!t) {
            setUser(null);
            return null;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch {
            setToken(null);
            setUser(null);
            return null;
        }
    }, []);

    useEffect(() => {
        refreshMe();
    }, [refreshMe]);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setToken(data.access_token);
        setUser(data.user);
        return data.user;
    }, []);

    const logout = useCallback(() => {
        setToken(null);
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, login, logout, refreshMe }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used within AuthProvider");
    return ctx;
}
